import React from "react";
import { arrayOf, bool, element, func, string, shape } from "prop-types";
import Button from "pages/_components/Button";
import Dropdown from "pages/_components/Dropdown";

export default function ContextMenu({
    isDesktop,
    children,
    items,
    styleContext,
    contributorDropdown,
    imageDropdown,
    firstActions,
    dropBtnClass,
}) {
    ContextMenu.propTypes = {
        isDesktop: bool.isRequired,
        children: arrayOf(element),
        items: arrayOf({ label: string.isRequired, onClick: func }),
        styleContext: shape({}),
        contributorDropdown: bool,
        imageDropdown: string,
        firstActions: shape({}),
        dropBtnClass: string,
    };

    ContextMenu.defaultProps = {
        children: null,
        items: null,
        styleContext: {},
        contributorDropdown: false,
        imageDropdown: null,
        firstActions: null,
        dropBtnClass: "",
    };

    return (
        items &&
        items.length > 0 && (
            <div
                className={isDesktop ? "account-list-div" : "context-mobile"}
                onClick={(e) => e.preventDefault()}
                style={styleContext}
                onKeyDown={(e) => e.preventDefault()}
                role="button"
                tabIndex={0}>
                <Dropdown
                    image={imageDropdown || "context-menu.svg"}
                    bsStyle="link"
                    buttonClass={`context-menu-button context-menu-dropdown view-back ${
                        isDesktop ? "account-list-div" : "ml-0"
                    } ${contributorDropdown ? "contributor-dropdown" : ""} ${dropBtnClass}`}
                    imageStyle="context-menu-svg-img"
                    fitWidth>
                    {!isDesktop && firstActions}
                    {items.map((item) => (
                        <Button
                            label={item.label}
                            onClick={item.onClick}
                            className="dropdown__item-btn btn-b-none dropdown__item-btn-custom justify-content-start my-0 ml-0 w-100"
                        />
                    ))}
                    {children}
                </Dropdown>
            </div>
        )
    );
}
